export default __webpack_public_path__ + "1b99ce16cc0a89807d91f784fa102a85.webp";